/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ScheduledInvestmentProposalConflictsResponse model module.
 * @module model/ScheduledInvestmentProposalConflictsResponse
 * @version 1.0.0
 */
class ScheduledInvestmentProposalConflictsResponse {
    /**
     * Constructs a new <code>ScheduledInvestmentProposalConflictsResponse</code>.
     * @alias module:model/ScheduledInvestmentProposalConflictsResponse
     */
    constructor() { 
        
        ScheduledInvestmentProposalConflictsResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ScheduledInvestmentProposalConflictsResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ScheduledInvestmentProposalConflictsResponse} obj Optional instance to populate.
     * @return {module:model/ScheduledInvestmentProposalConflictsResponse} The populated <code>ScheduledInvestmentProposalConflictsResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ScheduledInvestmentProposalConflictsResponse();

            if (data.hasOwnProperty('conflict_user_count')) {
                obj['conflict_user_count'] = ApiClient.convertToType(data['conflict_user_count'], 'Number');
            }
            if (data.hasOwnProperty('conflict_user_ids')) {
                obj['conflict_user_ids'] = ApiClient.convertToType(data['conflict_user_ids'], ['Number']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ScheduledInvestmentProposalConflictsResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ScheduledInvestmentProposalConflictsResponse</code>.
     */
    static validateJSON(data) {
        // ensure the json data is an array
        if (!Array.isArray(data['conflict_user_ids'])) {
            throw new Error("Expected the field `conflict_user_ids` to be an array in the JSON data but got " + data['conflict_user_ids']);
        }

        return true;
    }


}



/**
 * 同じ暦日に送信予約が入っているユーザー数
 * @member {Number} conflict_user_count
 */
ScheduledInvestmentProposalConflictsResponse.prototype['conflict_user_count'] = undefined;

/**
 * 同じ暦日に送信予約が入っているユーザー ID
 * @member {Array.<Number>} conflict_user_ids
 */
ScheduledInvestmentProposalConflictsResponse.prototype['conflict_user_ids'] = undefined;






export default ScheduledInvestmentProposalConflictsResponse;

